import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { QuproList, PhotoIssue, QuproServiceError } from '@arpada/arp-lib-common-qupro';

import { PortalProveedorService, UiService } from '../../../services/api.services';
import { IssueFront } from '../../../models/api.models';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-issue-image',
  templateUrl: './issue-image.component.html',
  styleUrls: ['./issue-image.component.scss'],
})
export class IssueImageComponent implements OnInit {

  @Input() issueFront: IssueFront;
  @Input() isModal: boolean;
  photoIssue: PhotoIssue;
  readonly NO_PHOTO_URL: string =  environment.baseUrl + 'assets/noPhoto.png';
  readonly LOADING_PHOTO_URL: string = environment.baseUrl + 'assets/loadingPhoto.svg';
  base64ImagePrefix = 'data:image/jpeg;base64,';
  hasPhoto = false;
  noHasPhoto = false;
  loadingPhoto = true;
  photoUrl: string;
  constructor(private portalProveedorService: PortalProveedorService,
              private uiService: UiService,
              private modalCtrl: ModalController) { }

  ngOnInit() {
    this.portalProveedorService.getPhotoIssue(this.issueFront.id).subscribe((photoIssue: QuproList<PhotoIssue>) => {
      this.photoIssue = photoIssue.elements[0];
      this.loadingPhoto = false;
      if (this.photoIssue.photo.length > 0) {
        this.hasPhoto = true;
        this.photoUrl = this.base64ImagePrefix + this.photoIssue.photo;
      } else {
        this.noHasPhoto = true;
      }
    }, (error: QuproServiceError) => {
      const message = 'id: ' + this.issueFront.id + ': ' + error.message;
      this.showErrorToast(message);
    });
  }

  exit() {
    this.modalCtrl.dismiss();
  }

  private showErrorToast(message: string) {
    this.uiService.showMiddleToastWithButton(message, 2000000);
  }
}
